import { metersToUm } from "@buildwithflux/shared";
import { IMPEDANCE_SPACING_MIN, IMPEDANCE_WIDTH_MIN, StripType } from "../../../../document";
import { getLayerIndex } from "./getLayerIndex";
// Default stackup top layer values
const DEFAULT_IMPEDANCE_PROPS = {
    thickness: 35,
    er: 4.3,
    height: 260,
    heightFromPlane: 260,
    width: IMPEDANCE_WIDTH_MIN,
    spacing: IMPEDANCE_SPACING_MIN,
};
function applyDielectricProps(dialectricLayers, impedanceProps) {
    if (dialectricLayers.length > 0) {
        impedanceProps.er = dialectricLayers[0].dielectric;
        const dielectricHeight = dialectricLayers.reduce((acc, layer) => acc + layer.thickness, 0);
        impedanceProps.height = metersToUm(dielectricHeight);
        impedanceProps.heightFromPlane = metersToUm(dielectricHeight);
    }
}
export function getImpedanceControlProperties(context, type) {
    const layer = context.this?.bakedRules?.layer;
    const stripType = context.this?.impedancePair || type === "paired" ? StripType.EDGE_COUPLED_MICROSTRIP : StripType.MICROSTRIP;
    const stackup = context.layout?.bakedRules?.stackup;
    if (!stackup) {
        return;
    }
    const stackupLayers = Object.values(stackup ?? {});
    const impedanceProps = { ...DEFAULT_IMPEDANCE_PROPS, type: stripType };
    if (layer === "Top") {
        // Find the top layer
        const layerIndex = getLayerIndex(stackupLayers, layer);
        if (layerIndex > -1) {
            const copperLayer = stackupLayers[layerIndex];
            impedanceProps.thickness = metersToUm(copperLayer.thickness);
            const dialectricLayers = [];
            let nextLayerIndex = layerIndex + 1;
            let nextLayer = stackupLayers[layerIndex + 1];
            while (nextLayer && nextLayer.type === "Dielectric") {
                dialectricLayers.push(nextLayer);
                nextLayerIndex++;
                nextLayer = stackupLayers[nextLayerIndex];
            }
            applyDielectricProps(dialectricLayers, impedanceProps);
        }
    }
    else if (layer === "Bottom") {
        // Find the bottom layer
        const layerIndex = getLayerIndex(stackupLayers, layer);
        if (layerIndex > -1) {
            const copperLayer = stackupLayers[layerIndex];
            impedanceProps.thickness = metersToUm(copperLayer.thickness);
            const dialectricLayers = [];
            let nextLayerIndex = layerIndex - 1;
            let nextLayer = stackupLayers[nextLayerIndex];
            while (nextLayer && nextLayer.type === "Dielectric") {
                dialectricLayers.push(nextLayer);
                nextLayerIndex--;
                nextLayer = stackupLayers[nextLayerIndex];
            }
            applyDielectricProps(dialectricLayers, impedanceProps);
        }
    }
    else if (layer) {
        // Routing on a mid layer need to use asym stripline calc
        // TODO - need to find the layer above and below the current layer
        const layerIndex = getLayerIndex(stackupLayers, layer);
        if (layerIndex > -1) {
            const copperLayer = stackupLayers[layerIndex];
            impedanceProps.thickness = metersToUm(copperLayer.thickness);
            const dialectricLayers = [];
            let belowLayerIndex = layerIndex + 1;
            let belowLayer = stackupLayers[belowLayerIndex];
            while (belowLayer && belowLayer.type === "Dielectric") {
                dialectricLayers.push(belowLayer);
                belowLayerIndex++;
                belowLayer = stackupLayers[belowLayerIndex];
            }
            let aboveLayerIndex = layerIndex - 1;
            let aboveLayer = stackupLayers[aboveLayerIndex];
            while (aboveLayer && aboveLayer.type === "Dielectric") {
                dialectricLayers.push(aboveLayer);
                aboveLayerIndex--;
                aboveLayer = stackupLayers[aboveLayerIndex];
            }
            applyDielectricProps(dialectricLayers, impedanceProps);
        }
        impedanceProps.type =
            context.this?.impedancePair || type === "paired"
                ? StripType.EDGE_COUPLED_STRIPLINE
                : StripType.SYMMETRIC_STRIPLINE;
    }
    return impedanceProps;
}
//# sourceMappingURL=impedanceControl.js.map